import Resource from '@/api/resource'
import request from '@/utils/request'

class Activities extends Resource {
  constructor() {
    super('activities')
  }

  list(query) {
    return request({
      url: `/${this.uri}/index`,
      method: 'POST',
      data: query,
    })
  }

  get(id) {
    return request({
      url: `/${this.uri}/show/${id}`,
      method: 'GET',
    })
  }

  store(data) {
    return request({
      url: `/${this.uri}/store`,
      method: 'POST',
      data,
    })
  }

  update(id, data) {
    return request({
      url: `/${this.uri}/update/${id}`,
      method: 'POST',
      data,
    })
  }

  LMSLookups(id) {
    return request({
      url: `/${this.uri}/lmsLookups/${id}`,
      method: 'GET',
    })
  }

  LMSCoursesLookups(id) {
    return request({
      url: `/${this.uri}/LMSCoursesLookups/${id}`,
      method: 'GET',
    })
  }

  LocalAssignmentsLookups(id) {
    return request({
      url: `/${this.uri}/LocalAssignmentsLookups/${id}`,
      method: 'GET',
    })
  }

  syncActivity(id, query) {
    return request({
      url: `/${this.uri}/syncActivity/${id}`,
      method: 'POST',
      data: query,
    })
  }

  SyncAllActivity(id) {
    return request({
      url: `/${this.uri}/SyncAllActivity/${id}`,
      method: 'POST',
    })
  }

  LMSAssignmentsLookups(id, course_id) {
    return request({
      url: `/${this.uri}/LMSAssignmentsLookups/${id}`,
      method: 'POST',
      data: course_id,
    })
  }
}

export { Activities as default }
